export const DISPLAY = {
    SHOW: 0,
    HIDE_EVENT: 1
};

function isInvestmentTypeSelectedInFilter(investment, options) {
    for (const high in options) {
        if (investment.itrnTtypDescription in options[high]) {
            return options[high][investment.itrnTtypDescription].selected;
        }
    }
    return false;
}

export function eventAllowedByIHFilters(accountTransactions, options) {
    const investmentShownStates = accountTransactions.flatMap(actr =>
        actr.investmentTransactions.map(iv => isInvestmentTypeSelectedInFilter(iv, options))
    );
    const numberOfInvestments = investmentShownStates.length;
    const numberOfFilteredInvestments = investmentShownStates.filter(f => f === false).length;
    return numberOfFilteredInvestments === numberOfInvestments ? DISPLAY.HIDE_EVENT : DISPLAY.SHOW;
}

export function eventAllowedByFilters(accountTransactions, options) {
    let hasBeenReversedOrDishonoured = false;
    const investmentShownStates = [].concat.apply(
        [],
        accountTransactions.map(actr => {
            return actr.investmentTransactions.map(iv => {
                if (iv.reversal || iv.dishonour) {
                    hasBeenReversedOrDishonoured = true;
                    return false;
                }
                for (const high in options) {
                    if (iv.itrnMappings.TRX_LOW_LEVEL in options[high]) {
                        return options[high][iv.itrnMappings.TRX_LOW_LEVEL].selected;
                    }
                }
                return true;
            });
        })
    );

    if (hasBeenReversedOrDishonoured) {
        return DISPLAY.HIDE_EVENT;
    }

    const numberOfInvestments = investmentShownStates.length;
    const numberOfFilteredInvestments = investmentShownStates.filter(f => f === false).length;
    return numberOfFilteredInvestments === numberOfInvestments ? DISPLAY.HIDE_EVENT : DISPLAY.SHOW;
}

export function showTotal(filters, searchOverride) {
    return !filters["All transactions"]["All transactions"].selected || searchOverride;
}

export function isDescriptionInActiveSearch(searchValue, description) {
    return searchValue.length > 0 && description.toUpperCase().includes(searchValue.toUpperCase());
}

export function shouldRenderThisTransactionEvent(
    searchValue,
    trevDesc,
    numberOfInvestmentRows,
    transactionEvent,
    filterOptions,
    isIncomeHistory = false,
    hasNoValidInvestments
) {
    if (isIncomeHistory && hasNoValidInvestments) {
        return false;
    }
    const allowedByFilters = isIncomeHistory
        ? eventAllowedByIHFilters(transactionEvent.accountTransactions, filterOptions) !== 1
        : eventAllowedByFilters(transactionEvent.accountTransactions, filterOptions) !== 1;
    const searchIsActive = searchValue !== undefined && searchValue.length > 0;
    const isDescriptionInSearch = isDescriptionInActiveSearch(searchValue, trevDesc);
    const hasVisibleInvestmentRows = numberOfInvestmentRows > 0;
    return (
        allowedByFilters &&
        (hasVisibleInvestmentRows || (searchIsActive ? isDescriptionInSearch : true))
    );
}

export function shouldRenderThisInvestmentTransaction(
    searchValue,
    investmentsShownForTrev,
    investmentNarrative
) {
    return (
        (investmentsShownForTrev && searchValue.length === 0) ||
        isDescriptionInActiveSearch(searchValue, investmentNarrative)
    );
}

export function investmentAllowedByFilters(filters, investmentTrx, isIncomeHistory = false) {
    if (isIncomeHistory) {
        return investmentTrx.itrnMappings.TRX_HISTORY !== "Hide";
    } else {
        return (
            investmentTrx.itrnMappings.TRX_HISTORY !== "Hide" &&
            filters[investmentTrx.itrnMappings.TRX_HIGH_LEVEL][
                investmentTrx.itrnMappings.TRX_LOW_LEVEL
            ].selected
        );
    }
}

export function getFeeLowLevel(desc) {
    return desc === "Advice fee (initial)" ? desc : "Product fees";
}

export function investmentOrderingComparator(a, b) {
    if (a.fake) {
        return -1;
    }
    if (b.fake) {
        return 1;
    }
    const dateCompare = a.itrnEffectiveDate.localeCompare(b.itrnEffectiveDate);
    if (dateCompare === 0) {
        if (a.fund.isin.toLowerCase().includes("cash")) {
            return -1;
        }
        if (b.fund.isin.toLowerCase().includes("cash")) {
            return 1;
        }
        return a.fund.longName.localeCompare(b.fund.longName);
    } else {
        return dateCompare;
    }
}
